'use strict';

var sdkUtil = require('./shared/sdk-util');

function isSearchUrl(url) {
  var urlSegments = url.split('/');

  // handles /search and /lang+lang/search
  if (urlSegments[1] === 'search' || urlSegments[2] === 'search') {
    return true;
  }

  return false;
}

module.exports = function () {
  return function (url) {
    var pathSegments, contentPath, sdk, version, last, matchedVersion, secondToLast;

    if (url === '/' || isSearchUrl(url)) {
      return {
        contentPath: url,
        sdk: undefined,
        version: undefined
      };
    }

    if (url.slice(-1) === '/') {
      url = url.slice(0, url.length - 1);
    }

    pathSegments = url.split('/');
    last = pathSegments.pop();
    matchedVersion = last.match(/^v?(\d+)$/);

    if (matchedVersion) {
      version = last;
    }
    if (!version) {
      // assign the full url to the content path in the case
      // that no sdk is present or the url is /lang
      if (!sdkUtil.isValidSdk(last) || pathSegments.length === 1) {
        contentPath = url;
      } else {
        contentPath = pathSegments.join('/');
        sdk = last;
      }
    } else {
      secondToLast = pathSegments.pop();

      if (!sdkUtil.isValidSdk(secondToLast)) {
        pathSegments.push(secondToLast);
        contentPath = pathSegments.join('/');
        version = undefined;
      } else {
        sdk = secondToLast;
        contentPath = pathSegments.join('/');
      }
    }

    return {
      contentPath: contentPath,
      sdk: sdk,
      version: version
    };
  };
};
